import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Stack } from '@mui/material';
import { Button } from '@elements/button';
import { StyledRangeButtonsWrapper } from './day-picker-range-buttons.styles';
import { getButtonProps } from './day-picker-range-buttons.helpers';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Date Picker range buttons.
 *
 * @author Mikhail Siutsou
 * @function DayPickerButtons
 * @category components
 * @param {DayPickerRangeButtonsProps} params day picker range buttons params.
 * @return {JSX.Element} DatePicker range buttons.
 */
var RangeButtons = function RangeButtons(_ref) {
  var range = _ref.range,
      selectedRange = _ref.selectedRange,
      handleButtonRange = _ref.handleButtonRange;
  return /*#__PURE__*/_jsx(StyledRangeButtonsWrapper, {
    children: /*#__PURE__*/_jsx(Stack, {
      direction: "row",
      spacing: 1,
      alignItems: "center",
      children: range.map(function (_ref2) {
        var label = _ref2.label,
            to = _ref2.to,
            from = _ref2.from;
        var buttonProps = getButtonProps({
          to: to,
          from: from
        }, selectedRange);
        return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
          variant: "contained",
          onClick: handleButtonRange({
            to: to,
            from: from
          })
        }, buttonProps), {}, {
          children: label
        }), label);
      })
    })
  });
};

export { RangeButtons };